var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_578_45619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2449 12.27C24.2449 11.48 24.1749 10.73 24.0549 10H12.7549V14.51H19.2249C18.9349 15.99 18.0849 17.24 16.8249 18.09V21.09H20.6849C22.9449 19 24.2449 15.92 24.2449 12.27Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7549 24C15.9949 24 18.7049 22.92 20.6849 21.09L16.8249 18.09C15.7449 18.81 14.3749 19.25 12.7549 19.25C9.62492 19.25 6.97492 17.14 6.02492 14.29H2.04492V17.38C4.01492 21.3 8.06492 24 12.7549 24Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02488 14.2901C5.77488 13.5701 5.64488 12.8001 5.64488 12.0001C5.64488 11.2001 5.78488 10.4301 6.02488 9.71012V6.62012H2.04488C1.22488 8.24012 0.754883 10.0601 0.754883 12.0001C0.754883 13.9401 1.22488 15.7601 2.04488 17.3801L6.02488 14.2901Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7549 4.75C14.5249 4.75 16.1049 5.36 17.3549 6.55L20.7749 3.13C18.7049 1.19 15.9949 0 12.7549 0C8.06492 0 4.01492 2.7 2.04492 6.62L6.02492 9.71C6.97492 6.86 9.62492 4.75 12.7549 4.75Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578_45619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.2b556a5ade3a5f0f3d59db91cc6068ac.svg";
export { ForwardRef as ReactComponent };